import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom';
import AboutContent from '../components/AboutContent'; 
import axios from 'axios'; 

import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import { Helmet } from "react-helmet";
import { base_url} from '../common/Constants';
 
class About extends React.Component{

    constructor(){
        super(); 
    }
 
    render()
    {
        const content = JSON.parse(localStorage.getItem("content"));
        const metas = JSON.parse(localStorage.getItem("metas"));
        return (
            <div className="page-wrapper">
                <Header/> 
                <Helmet>
                    <title>{metas[1].title}</title>  
                    <meta name="description" content={metas[1].meta_description} />
                    <meta name="keywords" content={metas[1].meta_title} />
                    <meta property="og:image" content={content[5].image}  />
                    <link rel="canonical" href={base_url+'about-us'} />
                </Helmet>
                <PageHeader title="About Us" banner="About"/>
                <AboutContent content={JSON.parse(localStorage.getItem("content"))} />  
                <Footer/>
            </div>
       
        )
    }

}
export default About;